(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- hero carousel ---------- */
  var hero = $('[data-hero-carousel]');
  if (hero) {
    var slides = $$('[data-hero-slide]', hero);
    var dots = $$('[data-hero-dot]', hero);
    var currentSlide = 0;
    var heroTimer = null;
    var touchStartX = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function showHero(index) {
      currentSlide = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === currentSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === currentSlide;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }
    function stopHero() { if (heroTimer) clearInterval(heroTimer); heroTimer = null; }
    function startHero() { stopHero(); if (!reduceMotion) heroTimer = setInterval(function () { showHero(currentSlide + 1); }, 5500); }
    $('[data-hero-prev]', hero).addEventListener('click', function () { showHero(currentSlide - 1); startHero(); });
    $('[data-hero-next]', hero).addEventListener('click', function () { showHero(currentSlide + 1); startHero(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { showHero(Number(dot.dataset.heroDot)); startHero(); }); });
    hero.addEventListener('mouseenter', stopHero);
    hero.addEventListener('mouseleave', startHero);
    hero.addEventListener('focusin', stopHero);
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) startHero(); });
    hero.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; stopHero(); }, { passive: true });
    hero.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - touchStartX; if (Math.abs(dx) > 45) showHero(currentSlide + (dx < 0 ? 1 : -1)); startHero(); }, { passive: true });
    startHero();
  }

  /* ---------- pincode gate before checkout ---------- */
  var coForm = $('[data-checkout-form]');
  if (coForm) {
    var coPin = $('[data-checkout-pin]', coForm);
    var coMsg = $('[data-checkout-pin-msg]', coForm);
    var okPins = (window.MCR_PINCODES || []).map(function (p) { return String(p).trim(); });
    function pinError(t) { coMsg.textContent = t; coMsg.hidden = !t; coPin.classList.toggle('is-invalid', !!t); }
    coPin.addEventListener('input', function () { coPin.value = coPin.value.replace(/\D/g, '').slice(0, 6); pinError(''); });
    coForm.addEventListener('submit', function (e) {
      var v = coPin.value.trim();
      if (!/^\d{6}$/.test(v)) { e.preventDefault(); pinError('Please enter a valid 6-digit pincode.'); coPin.focus(); return; }
      if (okPins.indexOf(v) === -1) { e.preventDefault(); pinError("Sorry, we don't deliver to " + v + ' yet. We deliver only to ' + okPins.join(', ') + '.'); coPin.focus(); }
    });
  }

  /* ---------- category filter + search ---------- */
  var searchInput = $('[data-menu-search]');
  var catCount = $('[data-cat-count]');
  var activeCat = '__all';

  function applyFilters() {
    var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var shownItems = 0;
    $$('[data-section]').forEach(function (sec) {
      var inCat = activeCat === '__all' || sec.dataset.section === activeCat;
      var visible = 0;
      $$('[data-product]', sec).forEach(function (card) {
        var haystack = card.dataset.title + ' ' + card.dataset.type + ' ' + card.dataset.tags;
        // a search looks across every category; otherwise respect the selected one
        var hit = q ? haystack.indexOf(q) > -1 : inCat;
        card.hidden = !hit;
        if (hit) visible++;
      });
      sec.hidden = visible === 0;
      shownItems += visible;
    });
    var none = $('[data-no-results]');
    if (none) none.hidden = shownItems > 0;
    if (catCount) catCount.textContent = shownItems ? shownItems + (shownItems === 1 ? ' item' : ' items') : '';
    $$('[data-cat]').forEach(function (l) {
      if (l.dataset.cat === activeCat) l.classList.add('active'); else l.classList.remove('active');
    });
  }

  function setCategory(handle, scroll) {
    activeCat = handle || '__all';
    if (searchInput) searchInput.value = '';
    applyFilters();
    if (scroll) {
      var menu = $('[data-menu]');
      if (menu) window.scrollTo({ top: menu.getBoundingClientRect().top + window.pageYOffset - 130, behavior: 'smooth' });
    }
  }

  $$('[data-cat]').forEach(function (link) {
    link.addEventListener('click', function (e) { e.preventDefault(); setCategory(link.dataset.cat, true); });
  });
  if (searchInput) searchInput.addEventListener('input', applyFilters);

  /* ---------- cart (fully optimistic, no re-fetch of markup) ---------- */
  var qty = {};
  var meta = {};   // variantId -> { price, name, thumb }
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
  var pending = {};
  var syncTimer = null;

  function formatMoney(cents, cur) {
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur || currency }).format(cents / 100); }
    catch (error) { return '\u20B9' + (cents / 100).toFixed(2); }
  }

  function readMeta() {
    $$('[data-variant]').forEach(function (slot) {
      var id = slot.dataset.variant;
      meta[id] = {
        price: Number(slot.dataset.price || (meta[id] && meta[id].price) || 0),
        name: slot.dataset.name || (meta[id] && meta[id].name) || 'Item',
        thumb: slot.dataset.thumb || (meta[id] && meta[id].thumb) || ''
      };
    });
  }

  function stepperNode(id, quantity) {
    var wrap = document.createElement('span');
    wrap.className = 'qty qty--card';
    wrap.innerHTML =
      '<button type="button" data-vqty="' + id + '" data-step="-1" aria-label="Remove one">&minus;</button>' +
      '<span data-vnum="' + id + '">' + quantity + '</span>' +
      '<button type="button" data-vqty="' + id + '" data-step="1" aria-label="Add one">+</button>';
    return wrap;
  }

  function paintSlot(id) {
    var quantity = qty[id] || 0;
    $$('[data-variant="' + id + '"]').forEach(function (slot) {
      var num = slot.querySelector('[data-vnum]');
      if (quantity > 0 && num) { num.textContent = quantity; return; }
      slot.textContent = '';
      if (quantity > 0) {
        slot.appendChild(stepperNode(id, quantity));
        slot.classList.add('is-active');
      } else {
        var btn = document.createElement('button');
        btn.className = 'btn';
        btn.type = 'button';
        btn.setAttribute('data-add', id);
        btn.textContent = 'Add';
        slot.appendChild(btn);
        slot.classList.remove('is-active');
      }
      slot.classList.remove('bump');
      void slot.offsetWidth;
      slot.classList.add('bump');
    });
  }

  function renderPanel() {
    var lines = $('[data-cart-lines]');
    if (!lines) return;
    var ids = Object.keys(qty);
    var html = '';
    ids.forEach(function (id) {
      var m = meta[id] || { price: 0, name: 'Item', thumb: '' };
      html +=
        '<div class="line">' +
        (m.thumb ? '<img src="' + m.thumb + '" alt="" width="56" height="56">' : '') +
        '<div style="flex:1;min-width:0">' +
        '<div class="line__t">' + m.name + '</div>' +
        '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px;gap:8px">' +
        '<span class="qty">' +
        '<button type="button" data-vqty="' + id + '" data-step="-1" aria-label="Decrease">&minus;</button>' +
        '<span data-vnum="' + id + '">' + qty[id] + '</span>' +
        '<button type="button" data-vqty="' + id + '" data-step="1" aria-label="Increase">+</button>' +
        '</span>' +
        '<span class="price">' + formatMoney(qty[id] * m.price) + '</span>' +
        '</div></div></div>';
    });
    lines.innerHTML = html;
    var empty = $('[data-cart-empty]');
    if (empty) empty.hidden = ids.length > 0;
    var checkout = $('[data-checkout-btn]');
    if (checkout) checkout.disabled = ids.length === 0;
  }

  function paintTotals() {
    var count = 0, total = 0;
    Object.keys(qty).forEach(function (id) {
      count += qty[id];
      total += qty[id] * ((meta[id] && meta[id].price) || 0);
    });
    var strip = $('.basketstrip');
    if (strip) strip.hidden = count === 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var label = $('[data-cart-count-label]');
    if (label) label.textContent = count === 1 ? 'item' : 'items';
    $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(total); });
    if (!count) document.body.classList.remove('basket-open');
  }

  function setQty(id, quantity) {
    quantity = Math.max(0, quantity);
    if (quantity) qty[id] = quantity; else delete qty[id];
    paintSlot(id);
    paintTotals();
    renderPanel();
    pending[id] = quantity;
    queueSync();
  }

  function queueSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      var updates = pending;
      pending = {};
      if (!Object.keys(updates).length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).catch(function () {});
    }, 350);
  }

  readMeta();
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      currency = cart.currency || currency;
      (cart.items || []).forEach(function (item) {
        var id = String(item.variant_id);
        qty[id] = item.quantity;
        meta[id] = {
          price: item.price,
          name: (meta[id] && meta[id].name) || item.product_title || item.title,
          thumb: (meta[id] && meta[id].thumb) || item.image || ''
        };
      });
      Object.keys(qty).forEach(paintSlot);
      paintTotals();
      renderPanel();
    })
    .catch(function () {});

  /* instant response: act on pointerdown, swallow the follow-up click */
  function handleAction(target, e) {
    var toggle = target.closest('[data-basket-toggle]');
    if (toggle) {
      e.preventDefault();
      var open = document.body.classList.toggle('basket-open');
      var strip = $('.basketstrip');
      if (strip) strip.setAttribute('aria-expanded', open ? 'true' : 'false');
      return true;
    }
    var add = target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      setQty(add.dataset.add, (qty[add.dataset.add] || 0) + 1);
      return true;
    }
    var step = target.closest('[data-vqty]');
    if (step) {
      e.preventDefault();
      var id = step.dataset.vqty;
      setQty(id, (qty[id] || 0) + Number(step.dataset.step || 0));
      return true;
    }
    return false;
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.button && e.button !== 0) return;
    handleAction(e.target, e);
  }, { passive: false });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-basket-toggle],[data-add],[data-vqty]')) { e.preventDefault(); return; }
  });

  applyFilters();
})();
